"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSYS_ATTRS = {
    cid: '_osys:cid',
    field: 'osys:field',
    'field:target': 'osys:field:target',
    'field:targets': 'osys:field:targets',
    'field:type': 'osys:field:type',
    group: 'osys:group',
    hidden: 'osys:hidden',
    hideable: 'osys:hideable',
    id: '_osys:id',
    lockable: 'osys:lockable',
    locked: 'osys:locked',
    name: 'osys:name',
    osys: 'osys',
    repeat: 'osys:repeat',
    repeater: 'osys:repeater',
    social: 'osys:social',
};
exports.BLOCK_TYPES = [
    {
        attrs: ['osys:field', /osys:field:\d+/],
        type: 'field',
        weight: 0,
    },
    {
        attrs: ['osys:group'],
        type: 'group',
        weight: 1,
    },
    {
        attrs: ['osys:repeater'],
        type: 'repeater',
        weight: 3,
    },
    {
        attrs: ['osys:social'],
        type: 'social',
        weight: 4,
    },
];
exports.OSYS_CHILD_TARGETS = ['contents', 'content', 'children', 'inner'];
//# sourceMappingURL=constants.js.map